import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IrisDmsLinkedFilesStore } from '@iris/common/modules/dms/store/linked-files.signal-store';
import { TranslatePipe } from '@ngx-translate/core';
import { StrakitClickStopPropagationDirective } from '@ngx-strakit/cdk';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';

@Component({
  selector: 'iris-dms-unlink-file-to-file-button',
  templateUrl: './dms-unlink-file-to-file-button.component.html',
  styleUrls: ['./dms-unlink-file-to-file-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslatePipe,
    MatTooltipModule,
    StrakitButtonComponent,
    StrakitClickStopPropagationDirective,
  ],
})
export class IrisDmsUnlinkFileToFileButtonComponent {
  private readonly linkedFilesStore = inject(IrisDmsLinkedFilesStore);

  public readonly fileId = input.required<string>();
  public readonly linkedFileId = input.required<string>();
  public readonly cssClass = input<string>('btn-link');

  removeLink(): void {
    this.linkedFilesStore.unlinkFile({ fileId: this.fileId(), linkedFileId: this.linkedFileId() });
  }
}
